/* istanbul ignore file */
import React from 'react';
import { DropDownFilter } from 'framework/list';
import LeadSourceDropdown from 'domain/sales/lead/shared/input/LeadSourceDropdown';
import { DefaultDropdownProps } from 'framework/form';

const LeadSourceFilter = (props: Omit<DefaultDropdownProps, 'options'>) => {
  return (
    <DropDownFilter {...props}>
      <LeadSourceDropdown {...props} />
    </DropDownFilter>
  );
};

export default LeadSourceFilter;
